import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import { useDomainContext } from "@hooks/useDomainContext";
import ClearYourDebtsFastWrapper from "@components/layouts/clearYourDebtsFastWrapper";

export default function TermsAndConditionsHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <ClearYourDebtsFastWrapper>
            <TermsAndConditions
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </ClearYourDebtsFastWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
